import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import ProductCard from "./ProductCard";

export const BestSellers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products/best-sellers", { params: { limit: 6 } })
      .then((r) => setItems((r.data || []).filter((p) => p.is_best_seller === true)))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      data-testid="best-sellers-section"
      className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32"
    >
      <div className="flex items-end justify-between mb-14 md:mb-20 gap-6">
        <div>
          <p className="text-[11px] tracking-overline uppercase text-[#D4AF37] mb-4 font-bold">
            № 02 — The most poured
          </p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight text-[#F4EAD9]">
            Best <span className="italic">sellers</span>
          </h2>
        </div>
        <Link
          data-testid="best-sellers-view-all"
          to="/shop?best=1"
          className="hidden sm:inline-flex items-center gap-2 text-[11px] tracking-overline uppercase text-[#F4EAD9] editorial-link font-bold"
        >
          View all <ArrowUpRight size={14} strokeWidth={1.2} />
        </Link>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {[0, 1, 2].map((i) => (
            <div key={i} className="aspect-[4/5] bg-[#1F1A17]" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {items.map((p, idx) => (
            <ProductCard key={p.id} product={p} index={idx} />
          ))}
        </div>
      )}
    </section>
  );
};

export default BestSellers;
